export default "__VITE_PUBLIC_ASSET__346e0b37__"